import { CLEAR_ALL, LOGOUT } from '../../../store/Types';

export const ALL_USU_VISTAS = 'ALL_USU_VISTAS';
export const LOADING_ALL_USU_VISTAS = 'LOADING_ALL_USU_VISTAS';
export const ACTIVO_USU_VISTAS = 'ACTIVO_USU_VISTAS';
export const PARAMS_USU_VISTAS = 'PARAMS_USU_VISTAS';

const initialState = {
  all: [],
  loadingAll: false,
  activo: null,
  params: {},
};

export const usuVistasReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_USU_VISTAS:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case LOADING_ALL_USU_VISTAS:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case ACTIVO_USU_VISTAS:
      return {
        ...state,
        activo: action.payload,
      };
    case PARAMS_USU_VISTAS:
      return {
        ...state,
        params: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
